import {reactive, ref, watch} from "vue";
import useDebounce from "@/composables/useDebounce";
import useForm from "@/composables/useForm";

export default function () {
    const filters = reactive({
        search: "",
        tags: [],
        rating: 3,
        ratingFilterState: 'all',
        ratingCondition: '',
        categories: [],
        trackers: [],
        ecosystems: [],
        stages: [],
        addedByMe: false,
        addedByEcosystems: false,
        trackerFields: [],
        profileFields: [],
    });

    const {resetForm, formFilled} = useForm(filters);

    const serverFilters = ref({});
    
    function applyFiltersChange() {
        serverFilters.value = {
            ...filters,
            tags: filters.tags.map(item => item.id),
            categories: filters.categories.map(item => item.id),
            trackers: filters.trackers.map(item => item.id),
            ecosystems: filters.ecosystems.map(item => item.id),
            stages: filters.stages.map(item => item.id),
        };
    }

    const debounce = useDebounce();

    watch(() => filters, () => debounce(applyFiltersChange, 2000), { deep: true });

    return {filters, serverFilters, resetForm, formFilled};
}
